export function obterListaEspecieVeiculo() {
  return (
    [
      { label: '1 - Passageiro', value: 'PASSAGEIRO' },
      { label: '2 - Carga', value: 'CARGA' },
      { label: '3 - Misto', value: 'MISTO' },
      { label: '4 - Corrida', value: 'CORRIDA' },
      { label: '5 - Tração', value: 'TRACAO' },
      { label: '6 - Especial', value: 'ESPECIAL' },
      { label: '7 - Coleção', value: 'COLECAO' },
    ]
  );
}
